<h2
  mat-dialog-title
  mat-dialog-draggable-title
  style="margin-bottom: 0px !important"
>
  <span style="color: #ff0202">{{ "alert.error" | translate }}</span>
  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-dialog-content>
  <mat-divider></mat-divider>
  <div class="row mt-4" style="padding: 5px 10px">
    <div class="pl-0" style="font-size: medium; overflow-wrap: break-word">
      <div [innerHTML]="title | translate"></div>
      <div *ngFor="let item of data; let i = index">{{ i + 1 }}. {{ item }}</div>
      <div [innerHTML]="handle | translate"></div>
    </div>
  </div>
  <mat-divider></mat-divider>
</mat-dialog-content>
<div mat-dialog-actions class="justify-content-end">
  <!--build icon, set default cancel-->
  <button mat-raised-button color="primary" [mat-dialog-close]="true">
    {{ "button.close" | translate }}
  </button>
</div>
